export default __webpack_public_path__ + "static/media/bg.9d696da8.svg";